// DO NOT TOUCH THE BELOW LINE
import store from "./app/store";
import reportWebVitals from "./reportWebVitals";

import React from "react";
import { Provider } from "react-redux";
import App from "./App"; // Ensure this is correctly imported
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from "react-router-dom";
import { SnackbarProvider } from "notistack";
// DO NOT TOUCH THE BELOW 3 LINES
if (window.Cypress) {
  window.store = store;
}

// WRITE YOUR CODE HERE

const container = document.getElementById('root')

if (container) {
  const root = createRoot(container)

  root.render(
    <BrowserRouter>
    <SnackbarProvider>
    <Provider store={store}>
      <App />
    </Provider>
    </SnackbarProvider>
    </BrowserRouter>
  )
} else {
  throw new Error(
    "Root element with ID 'root' was not found in the document. Ensure there is a corresponding HTML element with the ID 'root' in your HTML file.",
  )
}

// DO NOT TOUCH THE BELOW LINE
reportWebVitals();
